<template>
  <div class="discount-coupon clearfix">
    <p class="child ratio">
      <RichText class="rich-text" :text="info.content" />
    </p>
    <span class="child railing"></span>
    <div class="child coupon-des">
      <p class="title">{{ info.title }}</p>
      <p v-if="info.subTitle" class="sub-title">{{ info.subTitle }}</p>
    </div>
  </div>
</template>

<script>
import RichText from '@/components/RichText/index.vue';

export default {
  name: 'ShopDiscountCoupon',
  components: {
    RichText,
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    hasSub() {
      return !!this.info.subTitle;
    },
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.discount-coupon {
  position: relative;
  display: flex;
  padding: rem(11) rem(20);
  height: rem(68);
  background-image: linear-gradient(270deg, #ff8040 39%, #ff5e0d 99%);
  border-radius: rem(20);
  .child {
    align-self: center;
  }
  .ratio {
    float: left;
    ::v-deep .line {
      display: inline-block;
    }
    .rich-text {
      font-family: DiDiSans-Pro-Regular;
      ::v-deep span {
        vertical-align: middle;
      }
    }
  }
  .railing {
    float: left;
    display: block;
    margin: rem(5) rem(14);
    width: 0;
    height: rem(36);
    @include thinBorder(left, #fff);
    &:after {
      border-style: dashed;
    }
  }
  .coupon-des {
    float: left;
    max-width: rem(190);
    p {
      font-size: rem(20);
      color: #ffffff;
      @include ellipsis();
    }
    .title {
      font-family: DiDiSans-Pro-Bold;
      font-weight: 700;
    }
    .sub-title {
      margin-top: rem(2);
      font-family: DiDiSans-Pro-Regular;
      font-weight: 400;
    }
  }
  &:before {
    content: '';
    position: absolute;
    left: rem(-11);
    top: 50%;
    margin-top: rem(-8);
    height: rem(16);
    width: rem(16);
    border-radius: 50%;
    background: #fff;
  }
  &:after {
    content: '';
    position: absolute;
    right: rem(-11);
    top: 50%;
    margin-top: rem(-8);
    height: rem(16);
    width: rem(16);
    border-radius: 50%;
    background: #fff;
  }
}
</style>
